import React, {useState, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Button, Col, DatePicker, Form, Input, Popconfirm, Row, Select, Space, Table, Tabs, Typography} from 'antd';
import PageContent from '../../components/page-content/page-content';
import Box from '../../components/box';
import {getcwsrdjAll, deletecwsrdj, getcwzcdjstat} from "../../lib/api_cw_zcfkd";
import SrdjAddModal from "../manage/cw/srdj_add_modal";
import SrdjEditModal from "../manage/cw/srdj_edit_modal";
import excelUtil from "../../lib/excelUtil";
import moment from "moment/moment";
import ExcelJS from "exceljs";
import {saveAs} from 'file-saver';
import useUrlState from '@ahooksjs/use-url-state';
import {getcwcoaAll} from "../../lib/api_cw_coa";
import Decimal from 'decimal.js'
import COASelect from '../manage/cw/coa_select2'
import styles from './srdjtj.module.css';
import Srdj_edit_modal from "./srdj_edit_modal";

const {Column} = Table;
const {RangePicker} = DatePicker;


const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
    },
};


const Srdj = (props) => {
    const [data, setData] = useState([]);
    const [COA, setCOA] = useState(2);
    const [month, setmonth] = useState(moment());

    const fetchData = () => {
        // setData([]);
        getcwzcdjstat(month.format("YYYY-MM"), COA)
            .then((res) => {
                if (res.code === 0) {
                    dealData(res.data);
                    // setData(res.data);
                }
            })
    }

    useEffect(fetchData, [month, COA]);

    const dealData = (data) => {
        let {coas, srdjs, month} = data;
        // 数据处理
        // let coas_tree = listToTree(coas);
        // 在data数组中筛选出字段"md",进行分组
        // const uniqueMds = [...new Set(srdjs.map(item => item.md))].sort();
        const uniqueMds = ["门店1"];
        // const sortedMds = uniqueMds.sort();
        let groupedData = [];
        for (let i = 0; i < uniqueMds.length; i++) {
            let md = uniqueMds[i];
            let filteredData = srdjs.filter(item => item.md === md);
            let item = {
                md,
                columns: buildColumns(month, md)
            }
            tj(item, filteredData, month, coas);
            // 统计数据
            groupedData.push(item);
        }
        // let hj = {
        //     md: "合计",
        //     columns: buildColumns(month, "合计")
        // };
        // tj(hj, srdjs, month, coas);
        // groupedData.push(hj);
        setData(groupedData);
    }

    const buildColumns = (month, md) => {
        let list = [{
            title: '项目',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 300
        }];
        let begin = moment(month, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
        let end = moment(month, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
        // 从begin到end把list到数据都初始化为0
        for (let i = begin; i <= end; i = moment(i).add(1, 'days').format("YYYY-MM-DD")) {
            list.push({
                title: parseInt(moment(i).format("D")),
                dataIndex: i,
                key: i,
                align: "center",
                render: (text, record, index) => {
                    return new Decimal(record[i].je).toNumber();
                }
            })
        }
        list.push({
            title: "合计",
            dataIndex: "je",
            key: "je",
            align: "center",
            fixed: 'right',
            width: 130,
            render: (text, record) => {
                let num = new Decimal(0);
                for (let i = begin; i <= end; i = moment(i).add(1, 'days').format("YYYY-MM-DD")) {
                    num = num.add(record[i].je);
                }
                return num.toString();
            }
        })
        return list;
    }

    const tj = (item, srdjs, month, coas) => {
        let md = item.md;
        let list = JSON.parse(JSON.stringify(coas));
        let begin = moment(month, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
        let end = moment(month, "YYYY-MM").endOf("month").format("YYYY-MM-DD");

        // // 在list的第一行插入数据
        // list.unshift({name: "现金流合计", pid: 0, id: -1});
        //
        // // 增加会员预收款条目
        // list.push({name: "会员预收款", pid: 0, id: 90000000});
        // list.push({name: "1 年费", pid: 90000000, id: 90000001});
        // list.push({name: "2 寄养费", pid: 90000000, id: 90000002});
        // list.push({name: "3 教练费", pid: 90000000, id: 90000003});
        // list.push({name: "4 次卡", pid: 90000000, id: 90000004});

        // 从begin到end把list到数据都初始化为0
        for (let i = 0; i < list.length; i++) {
            let item1 = list[i];
            item1.key = item.md + "_" + item1.id;
            for (let j = begin; j <= end; j = moment(j).add(1, 'days').format("YYYY-MM-DD")) {
                item1[j] = {
                    id: 0,
                    je: 0,
                    md: item.md,
                    date: j,
                    coa: item1.name,
                    coa_id: item1.id,
                    coa_pid: item1.pid,

                };
            }
        }
        // console.log(list);
        for (let i = 0; i < srdjs.length; i++) {
            let {coa_id} = srdjs[i];
            for (let j = 0; j < list.length; j++) {
                let item = list[j];
                if (item.id === coa_id) {
                    if (item[srdjs[i].fkrq]) {
                        item[srdjs[i].fkrq].je = new Decimal(item[srdjs[i].fkrq].je).add(srdjs[i].je).toString();
                    }
                    // item[srdjs[i].date].push(srdjs[i]);
                    // item[srdjs[i].date].je = (new Decimal(item[srdjs[i].date].je)).add(srdjs[i].je).toString();
                    // // console.log(item, JSON.stringify(item));
                    break;
                }
            }
        }


        // console.log(list, srdjs);

        item.data = listToTree(list, 0, month);
        // return list;

        // // 特殊处理现金流合计
        // let xjl = item.data[0];
        // // xjl.je = item.data[1];
        // for (let i = begin; i <= end; i = moment(i).add(1, 'days').format("YYYY-MM-DD")) {
        //     xjl[i].je = (new Decimal(item.data[1][i].je)).toString();
        //     // 减去会员
        //     let hy = item.data[1].children[0].children[0].children[1];
        //     xjl[i].je = (new Decimal(xjl[i].je).sub(hy[i].je)).toString();
        //     xjl[i].je = (new Decimal(xjl[i].je).add(item.data[2][i].je)).toString();
        // }
        // console.log(item.data[1].children[0].children[0].children[1]);

        // console.log(xjl)
    }

    // 递归将列表转成antd的树结构，父节点为pid，pid为0的为顶级节点
    const listToTree = (list, pid = 0, month) => {
        let begin = moment(month, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
        let end = moment(month, "YYYY-MM").endOf("month").format("YYYY-MM-DD");

        const tree = [];

        list.forEach(item => {
            if (item.pid === pid) {
                const children = listToTree(list, item.id, month);
                if (children.length) {
                    item.children = children;
                    // console.log(item);
                    for (let i = begin; i <= end; i = moment(i).add(1, 'days').format("YYYY-MM-DD")) {
                        item[i].je = item.children.reduce((sum, item) => {
                            // console.log(item);
                            return new Decimal(sum).add(item[i].je).toString();
                        }, 0);
                    }
                }
                tree.push(item);
            }
        });

        return tree;
    }

    const getExcelColumnName = (columnNumber) => {
        let columnName = '';
        let dividend = columnNumber;

        while (dividend > 0) {
            const remainder = (dividend - 1) % 26;
            columnName = String.fromCharCode(65 + remainder) + columnName;
            dividend = Math.floor((dividend - remainder) / 26);
        }

        return columnName;
    }

    const buildExcelRow = (worksheet, tree, indent, columns) => {
        if (!tree) {
            return;
        }
        tree.forEach((item, index) => {
            const rowCount = worksheet.rowCount;
            const row1 = worksheet.getRow(rowCount + 1);
            item.row = rowCount + 1;
            row1.getCell(1).value = item.name;
            if (indent) {
                row1.getCell(1).alignment = {
                    horizontal: 'left',
                    indent: indent
                }
            }
            // // 数据
            // for (let i = 1; i < columns.length - 1; i++) {
            //     row1.getCell(i + 1).value = parseFloat(item[columns[i].key].je);
            //     // row1.getCell(i + 1).numFmt = '0.00';
            // }
            let je = new Decimal(0);
            // 递归调用，将子节点转成列表
            if (item.children && item.children.length) {
                buildExcelRow(worksheet, item.children, indent + 1, columns);
                // 有子节点，生成求和公式
                for (let i = 1; i < columns.length - 1; i++) {
                    let a = item.children.map(child => {
                        return getExcelColumnName(i + 1) + child.row;
                    }).join(",");
                    let formula = `SUM(${a})`;
                    row1.getCell(i + 1).value = {formula, result: item[columns[i].key].je};
                    je = new Decimal(je).add(item[columns[i].key].je);
                    row1.getCell(i + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: 'e3f5ff'}
                    }
                }
                row1.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'e3f5ff'}
                }
            } else {
                // 没有子节点，组装数据
                for (let i = 1; i < columns.length - 1; i++) {
                    let note = item[columns[i].key].bz || "";
                    let formula = "=" + item[columns[i].key].je;
                    let result = parseFloat(item[columns[i].key].je);
                    // row1.getCell(i + 1).value = {formula, result};
                    row1.getCell(i + 1).value = result;
                    je = new Decimal(je).add(result);
                    if (note) row1.getCell(i + 1).note = note;

                    // if (item[columns[i].key].length) {
                    //     let note = `${item[columns[i].key][0].je}：${item[columns[i].key][0].bz || ""}\n`;
                    //     let formula = "=" + item[columns[i].key][0].je;
                    //     let result = parseFloat(item[columns[i].key][0].je);
                    //     for (let j = 1; j < item[columns[i].key].length; j++) {
                    //         formula += "+" + item[columns[i].key][j].je;
                    //         result += parseFloat(item[columns[i].key][j].je);
                    //         note += `${item[columns[i].key][j].je}:${item[columns[i].key][j].bz || ""}\n`;
                    //     }
                    //     row1.getCell(i + 1).value = {formula, result};
                    //     je = new Decimal(je).add(result);
                    //     row1.getCell(i + 1).note = note;
                    // } else {
                    //     row1.getCell(i + 1).value = 0;
                    // }
                }
            }
            // 最后一列使用求和公式
            row1.getCell(columns.length).value = {
                formula: `SUM(${getExcelColumnName(2) + item.row}:${getExcelColumnName(columns.length - 1) + item.row})`,
                result: je.toNumber()
            };
            if (item.children && item.children.length) {
                row1.getCell(columns.length).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'e3f5ff'}
                }
            }
        });
    };

    const exportXlsx = async () => {
        const workbook = new ExcelJS.Workbook();
        for (let i = 0; i < data.length; i++) {
            const worksheet = workbook.addWorksheet(data[i].md, {views: [{state: 'frozen', xSplit: 1, ySplit: 2}]});
            worksheet.getCell(1, 1).value = "JEC每日支出登记表-" + data[i].md;
            // 标题
            for (let j = 0; j < data[i].columns.length; j++) {
                worksheet.getCell(2, j + 1).value = data[i].columns[j].title;
            }
            worksheet.getColumn(1).width = 32;
            // 数据
            buildExcelRow(worksheet, data[i].data, 0, data[i].columns)
            // for (let j = 0; j < data[i].data.length; j++) {
            //     buildExcelRow(worksheet, data[i].data[j], 0)
            //     // worksheet.getCell(j + 3, 1).value = data[i].data[j].name; //名称
            //     // for (let k = 1; k < data[i].data[j].length; k++) {
            //     //     worksheet.getCell(j + 3, k + 1).value = data[i].data[j][k].je;
            //     // }
            // }
            worksheet.eachRow((row, rowNum) => {
                row.eachCell((cell, cellNum) => {
                    cell.border = {
                        top: {style: 'thin'},
                        left: {style: 'thin'},
                        bottom: {style: 'thin'},
                        right: {style: 'thin'}
                    };
                    if (rowNum >= 2 && cellNum >= 2) {
                        cell.alignment = {horizontal: 'center', vertical: 'middle'};
                    }
                })
            });
        }
        workbook.calcProperties.fullCalcOnLoad = true;

        //将data插入 工作表，并按照级别进行缩进
        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, `JEC每日支出登记表（${month.format("YYYY年MM月")}）_${moment().format("YYYYMMDDHHmmss")}.xlsx`)
    }


    return (
        <PageContent>
            <Box>
                月份：<DatePicker value={month} onChange={(value) => setmonth(value)} picker="month" allowClear={false}/>
                {/*科目：<COASelect value={COA} onChange={(value) => setCOA(value)}/>*/}
                <Link to={'/duizhang/zctjyue'}>查看月度统计</Link>
            </Box>
            <Box title={`财务支出统计（${month.format("YYYY年MM月")}）`}
                 extra={
                     <Space>
                         {/*<Button type='primary' onClick={() => setaddmodal(true)}>添加</Button>*/}
                         <Button type='primary' onClick={exportXlsx}>导出</Button>
                     </Space>
                 }
                 style={{marginBottom: 20, marginTop: 12}}
            >
                {data.length > 0 &&
                    <Tabs>

                        {data.map((item, index) => {
                            return (
                                <Tabs.TabPane tab={item.md} key={index}>
                                    <Table dataSource={item.data}
                                           key={item.md}
                                           columns={item.columns}
                                           pagination={false}
                                           size={"small"}
                                           scroll={{
                                               x: 3000,
                                           }}
                                           expandable={{
                                               defaultExpandAllRows: true
                                           }}
                                           className={styles.table}
                                           bordered
                                           rowClassName={(record, index) => {
                                               if (record.name === '现金流合计' || (record.children && record.children.length > 0)) {
                                                   return styles.row_sum;
                                               } else {
                                                   return null;
                                               }
                                           }}
                                    />
                                </Tabs.TabPane>
                            );
                        })}
                    </Tabs>
                }
            </Box>


        </PageContent>
    )
}

export default withRouter(Srdj);
